/**
 * TestMonitor React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2019 contexagon GmbH
 */


import React from 'react';
import {connect} from "react-redux";
// import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from '@material-ui/core/styles';


/**
 * TestMonitor is a React component displaying the test state
 *
 * @author Maurizio Tidei
 */
class TestMonitor extends React.Component {

    render() {

        return <div>
            <span>Rest Calls: {this.props.restcalls}</span>
        </div>
    }
}

const styles = {
    root: {
        flexGrow: 1,
    }
};

const mapStateToProps = state => {
    return {
        restcalls: state.testing.restcalls
    }
}

export default connect(mapStateToProps)(withStyles(styles)(TestMonitor));
